import React from "react";
import { Box, Typography, Stack, Chip, alpha, useTheme } from "@mui/material";
import { Inventory2, OilBarrel } from "@mui/icons-material";

const CargoTable = ({ loadedCargoes = [] }) => {
  const theme = useTheme();
  const hasCargo = loadedCargoes.length > 0;

  return (
    <Box sx={{ py: 1 }}>
      <Stack spacing={2}>
        {/* Header med ikon */}
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: 1.5,
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              color: "primary.main",
              display: "flex",
            }}
          >
            <Inventory2 sx={{ fontSize: 18 }} />
          </Box>
          <Typography
            variant="subtitle2"
            fontWeight="900"
            sx={{ letterSpacing: 0.5 }}
          >
            LOADED CARGO
          </Typography>
        </Stack>

        {/* Cargo List / Display */}
        <Box
          sx={{
            minHeight: 60,
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            p: 2,
            borderRadius: 3,
            bgcolor: alpha(theme.palette.action.hover, 0.5),
            border: "1px dashed",
            borderColor: "divider",
            alignItems: "center",
          }}
        >
          {hasCargo ? (
            loadedCargoes.map((cargo, index) => (
              <Chip
                key={index}
                icon={<OilBarrel sx={{ fontSize: "1rem !important" }} />}
                label={cargo}
                sx={{
                  bgcolor: "background.paper",
                  fontWeight: 800,
                  border: "1px solid",
                  borderColor: alpha(theme.palette.primary.main, 0.2),
                  px: 1,
                  "& .MuiChip-label": { px: 1.5 },
                }}
              />
            ))
          ) : (
            <Typography
              variant="body2"
              color="text.disabled"
              sx={{ fontStyle: "italic", ml: 1 }}
            >
              No cargo data recorded for this selection.
            </Typography>
          )}
        </Box>

        {/* Footer-info */}
        {hasCargo && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: 600, pl: 1 }}
          >
            Total grades: {loadedCargoes.length}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default CargoTable;
